module.exports = __webpack_public_path__ + "static/media/operations_dashboard_active.e214f848.svg";